import { memo } from 'react';
import { Trans } from 'react-i18next';

import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';
import { UiCard } from 'src/components/UI/Card';
import { UiMereLabel } from 'src/components/UI/UiMereLabel';

type Props = {
  model: CheckoutConfirmationResponseType['CheckInformationSubsection'];
};

export const CheckoutConfirmationCheckInformation = memo<Props>(({ model }) => {
  const locale = 'checkout.confirmation.checkInformation';
  const tHelper = useTHelper(locale);

  return (
    <>
      <h2 className="section-header">{tHelper('title')}</h2>
      <UiCard className="check-instructiions">
        {model.IsCampaignPledge && (
          <>
            {tHelper('text', { singular: model.ProjectTerminology.Singular?.toLowerCase() || '' })}
            <br />
            <br />
          </>
        )}
        <Trans i18nKey={`${locale}.check`} values={{ text: model.CheckPayableTo }}>
          <UiMereLabel>a</UiMereLabel>
        </Trans>
        <div className="check-info">{model.CheckName}</div>
        <div className="check-info">{model.CheckAttentionTo}</div>
        <div className="check-info">{model.CheckAddressLine1}</div>
        <div className="check-info">{model.CheckAddressLine2}</div>
        <div className="check-info">{model.CheckAddressLine3}</div>
        <div className="check-info">
          {model.CheckCity}, {model.CheckRegion} {model.CheckZipCode}
        </div>
        <div className="check-info">{model.CheckCountry}</div>

        {model.UnpaidCheckNotice && <div className="mt-15">{model.UnpaidCheckNotice}</div>}
      </UiCard>
    </>
  );
});
